const screenWidth = screen.width;
const screenHeight = screen.height;

const vars = {
    mobileThreshold: 641, // if you change this, you must change mobile-landscape-width in _variables.scss
    tabletThreshold: 1025, // same as above
    screenWidth: screenWidth,
    screenHeight: screenHeight,
    screenMaxWidth: Math.max(screenWidth, screenHeight),
    devicePixelRatio: 'devicePixelRatio' in window ? devicePixelRatio : 1,
    iOS: /iPad|iPhone|iPod/.test(navigator.userAgent)
};

// function getUrlParameterByName(name) {
//     name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
//     const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
//     const results = regex.exec(location.search);
//     return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
// }

// export default {
//     getUrlParameterByName,
//     vars
// };

export default vars;
